import { DecimalLimitInputDirective } from './../../../directives/decimal-limit-input.directive';
import { BillSaveData } from './../../../models/bill-save-data.interface';
import { CommonModule, DatePipe, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, computed, inject, input, Output, signal, ViewChild, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { EditModeDirective } from 'src/app/directives/edit-mode.directive';
import { ViewModeDirective } from 'src/app/directives/view-mode.directive';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'editable-detail',
  standalone: true,
  imports: [
    FaIconComponent,
    NgTemplateOutlet,
    ViewModeDirective,
    EditModeDirective,
    DecimalLimitInputDirective,
    DatePipe,
    FormsModule,
    CommonModule
  ],
  templateUrl: './editable-detail.component.html',
})
export class EditableDetailComponent implements AfterViewInit {
  @ViewChild(ViewModeDirective) viewModeTpl: ViewModeDirective | null = null;
  @ViewChild(EditModeDirective) editModeTpl: EditModeDirective | null = null;
  @Output() saveKey = new EventEmitter<BillSaveData>();
  editAllowed = input.required();
  viewInit = signal(false);
  icons = inject(IconsService);
  editValue = input.required<string | number>();
  isCurrency = input<boolean>(false);
  inputType = input<string>('text');
  keyForSaving = input.required<string>();
  inputValue = signal<string | number | null>(null);
  view = signal<'view' | 'edit'>('view');
  currentView = computed(() => {
      if (!this.viewInit() || !this.viewModeTpl || !this.editModeTpl) {
      return null;
    }
    return this.view() === 'view' ? this.viewModeTpl.tpl : this.editModeTpl.tpl;
  });

  set value(val: string | number | null) {
    this.inputValue.set(val);
  }

  get value() {
    return this.inputValue();
  }

  ngAfterViewInit(): void {
    this.setInitValue();
    this.viewInit.set(true);
  }

  setInitValue() {
    switch (this.inputType()) {
      case 'date':
        const date = new Date(this.editValue())?.toISOString().split('T')[0];
        this.inputValue.set(date);
        break;
      case 'number':
        const trunkData = /^\d*\.?\d{0,6}/.exec(this.editValue().toString());
        const trunkNumber = trunkData ? Number(trunkData[0]) : this.editValue();
        this.inputValue.set(trunkNumber);
        break;
      default:
        this.inputValue.set(this.editValue());
        break;
    }
  }

  onCancel() {
    this.setInitValue();
    this.switchMode('view');
  }

  switchMode(mode: 'view' | 'edit') {
    this.view.set(mode);
  }

  save() {
    if (this.inputValue()) {
      this.saveKey.emit({
        type: this.inputType(),
        key: this.keyForSaving(),
        value: this.inputValue()
      });
      this.view.set('view');
    }
  }

}
